export const URL_PARAMS = {
  RETURN_FROM_3DS: 'returnFrom3DS',
  TRANSACTION_ID: 'transactionId',
  ORDER_ID: 'order_id',
  STORED_PAYMENT_METHOD_ID: 'stored_payment_method_id',
} as const

export type URLParam = (typeof URL_PARAMS)[keyof typeof URL_PARAMS]
